// extracted by mini-css-extract-plugin
export default {"Rating":"VaO1oQTz","RatingA11y":"F1K0AHfw","Votes":"IJwh7W73","Big":"PAuEfoCJ","Stars":"nZ8RVTEp"};